import { mergeStyleSets } from '@fluentui/react';
import { IAdQualityFiltersClassNames } from './AdQualityFilters.types';

export const getClassNames = (): IAdQualityFiltersClassNames => {
  return mergeStyleSets({
    root: {},
  });
};
